import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { VisitedLinkModule } from '../../ui/visited-link/visited-link.module';
import { ReadMoreModule } from '../read-more/read-more.module';
import { ContentHtmlComponent } from './contentHtml.component';
import { NotificationComponent } from './notification.component';
import { NotifyDataTableComponent } from './notify-data-table/notify-data-table.component';
import { NotifyReadComponent } from './notify-read/notify-read.component';
import { NotifyUnreadComponent } from './notify-unread/notify-unread.component';

@NgModule({
  declarations: [
    NotificationComponent,
    NotifyUnreadComponent,
    NotifyReadComponent,
    NotifyDataTableComponent,
    ContentHtmlComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    VisitedLinkModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ReadMoreModule,
  ],
  exports: [
    NotificationComponent,
    NotifyUnreadComponent,
    NotifyReadComponent,
    NotifyDataTableComponent,
  ],
})
export class NotificationModule {}
